import { render } from "./MineBeholdere.vue?vue&type=template&id=b20a6392"
import script from "./MineBeholdere.vue?vue&type=script&lang=js"
export * from "./MineBeholdere.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__